import theme from '@styles/theme';
export default {
  informationRow: {
    p: ['25px 24px', '25px 24px', '0'],
    display: 'flex',
    flexFlow: ['column', 'column', 'row wrap'],
    justifyContent: 'space-between',
    alignItems: 'stretch',
    width: '100%'
  },
  informationItem: {
    flex: '1',
    textAlign: 'center',
    borderRight: ['none', 'none', `2px solid ${theme.rawColors.neutralBlack}`],
    p: ['0 24px', '0 24px', '0 1.8vw'],
    m: ['25px 0', '25px 0 ', '50px 0'],
    justifyContent: 'flex-start',
    minHeight: '100px',
    ':last-child': {
      border: 'none'
    }
  },
  informationIcon: {
    mb: '15px'
  }
};